import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useConversationItemStyles = makeStyles((theme: Theme) => ({
  listItem: {
    marginBottom: theme.spacing(0.5),
  },
  listItemButton: {
    borderRadius: '4px',
    padding: theme.spacing(1, 1.5),
    position: 'relative',
    color: theme.palette.text.primary,
    '&.Mui-selected, &.Mui-focusVisible, &.Mui-selected.Mui-focusVisible': {
      color: theme.palette.text.primary,
      backgroundColor:
        theme.palette.mode === 'dark' ? '#4A4A4A' : 'rgba(217, 217, 217, 0.70)',
      '&:hover': {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? '#4A4A4A'
            : 'rgba(217, 217, 217, 0.70)',
      },
      '& $title': {
        color:
          theme.palette.mode === 'dark'
            ? 'var(--xlrt-color-ui-white)'
            : 'var(--xlrt-color-ui-gray20)',
      },
    },
    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'dark' ? '#4A4A4A' : 'rgba(217, 217, 217, 0.70)',
      '& $title': {
        color:
          theme.palette.mode === 'dark'
            ? 'var(--xlrt-color-ui-white)'
            : 'var(--xlrt-color-ui-gray20)',
      },
    },
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  contentWithActions: {
    paddingRight: theme.spacing(6),
  },
  title: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    color:
      theme.palette.mode === 'dark'
        ? 'var(--xlrt-color-ui-gray85)'
        : 'var(--xlrt-color-ui-gray40)',
    maskImage:
      'linear-gradient(to right, black calc(100% - 2ch), transparent 100%)',
    WebkitMaskImage:
      'linear-gradient(to right, black calc(100% - 2ch), transparent 100%)',
  },
  renameInput: {
    fontSize: '0.875rem',
    lineHeight: 1.43,
    padding: 0,
    '& input': {
      padding: 0,
    },
  },
  actionsContainer: {
    position: 'absolute',
    right: theme.spacing(1),
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'inherit',
    borderRadius: theme.spacing(1),
  },
  popoverContent: {
    padding: theme.spacing(2),
    maxWidth: 250,
  },
  popoverActions: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
  },

  titleInner: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    transitionProperty: 'transform',
    transitionTimingFunction: 'ease',
    willChange: 'transform',
  },
  titleHovered: {
    maskImage: 'none',
    WebkitMaskImage: 'none',
  },
}));
